<template>
  <div class="league-select-list">
    <ul>
      <li
        v-for="league in leagues" :key="league.id"
        @click="updateSelected(league)"
        :class="{'selected-league': leagueId == league.id}">
        {{ league.name }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "LeagueSelectList",
    props: {
      leagues: {
        type: Array,
        default: () => []
      },
      leagueId: {
        required: true,
        validator: v => v == null || typeof v == "number"
      }
    },
    methods: {
      updateSelected(league) {
        this.$emit("update:leagueId", league.id);
      }
    }
  }
</script>

<style lang="scss">
.league-select-list {
  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 0 100px;
    justify-content: center;
    margin-bottom: 1rem;
    li {
      padding: 0.25rem;
      margin: 0.5rem 0.75rem;
      cursor: pointer;
      background-size: 400% 100% !important;
      background-position: 0 100% !important;
      opacity: 0.88 !important;
      transition: background-position 0.5s, opacity 1s !important;
      &:hover {
        opacity: 1 !important;
        transition: opacity 0.2s !important;
      }
    }
    li.selected-league {
      outline: 2px solid black !important;
      background-position: 100% 100% !important;
      opacity: 1 !important;
      transition: background-position 0.5s, opacity 1s !important;
    }
  }
  /* Assuming no more than 40 leagues right now. */
  @for $n from 1 to 40 {
    li:nth-child(#{$n}) {
      $first-start: hsla((($n * 36) % 360), 100%, 80%, 0.8);
      $first-end: lighten(transparentize($first-start, 0.2), 0.1);
      $second-start: hsla((($n * 36 + 36) % 360), 100%, 80%, 0.9);
      $second-end: lighten(transparentize($second-start, 0.2), 0.1);
      background: linear-gradient(to left, $first-start, $first-end), linear-gradient(to right, $second-start, $second-end);
    }
  }
}
</style>